import { Icons } from "../Icons/Icons";
import Scenes from "./components/Scenes/Scenes";
import MixerPopup from "./components/MixerPopup/MixerPopup";
import Youtube from "./components/Youtube/Youtube";
import Chat from "./components/Chat/ChatPopup";
import Timer from "./components/Timer/Timer";
import Note from "./components/Note/Note";
export const menuData = [
  {
    id: 0,
    icon: Icons.menumixer,
    icon_hovered: Icons.menumixerhovered,
    title: "Mixer",
    premium: false,
    coponent: MixerPopup,
  },
  {
    id: 1,
    icon: Icons.menutemplates,
    icon_hovered: Icons.menutemplateshovered,
    title: "Chat",
    premium: false,
    coponent: Chat,
  },
  {
    id: 2,
    icon: Icons.menuscenes,
    icon_hovered: Icons.menusceneshovered,
    title: "Scenes",
    premium: false,
    coponent: Scenes,
  },
  {
    id: 3,
    icon: Icons.menuyoutube,
    icon_hovered: Icons.menuyoutubehovered,
    title: "Youtube",
    premium: false,
    coponent: Youtube,
  },
  {
    id: 4,
    icon: Icons.menutimer,
    icon_hovered: Icons.menutimerhovered,
    title: "Timer",
    premium: false,
    coponent: Timer,
  },
  {
    id: 5,
    icon: Icons.menunotes,
    icon_hovered: Icons.menunoteshovered,
    title: "Notes",
    premium: false,
    coponent: Note,
  },
];
